<template>
    <div class="scrollableY">
        <div class="container has-text-white ">
               <div class="top80"> 
                    <div class="is-size-3">ADS</div>
                    <br>
                    <ad-metrics v-for="(item, index) in ads" :key="index" :item="item" :ind="index"></ad-metrics>
                </div>
         </div>
    </div>
</template>


<script>
import AdMetrics from '../components/AdMetrics'
import { AZEventBus } from '../components/AZEventBus'
export default {

        components: {AdMetrics},
        data: function(){
            return {
                inited: false,
                ads: []
            }
        },
        mounted: function(){
            var self = this

            function w(d){
                //console.log(d.data)
                self.ads = d.data
            }

            function n(){

            }

            function init(){
                az.addRemSpinner(true, "id", "mainDiv")
                self.inited = true;
                self.$root.app.apiClient.get('subs/data/ads', {}, w, n)
            }

            if(self.$root.app.doneFederating){
                init();
            }

            AZEventBus.$once('onFederate', msg => {
            if(self.inited == false)
                init();
            });

        }
    


       

}
</script>